import * as React from "react";
import Grid from "@mui/material/Grid";
import { useParams } from "react-router-dom";
import {Container, Typography } from "@mui/material";
import SingleProjectCard from "./SingleProjectCard";


const SingleProject = () => {
  
  const { projectID } = useParams();
  const [singleprojectlist, setSingleprojectlist] = React.useState({});
  const [isLoading, setIsLoading] = React.useState(true);
  React.useEffect(() => {
    fetch("/allprojects.json")
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        // setsinglebloglist(data);
        // eslint-disable-next-line eqeqeq
        const singleprojectlistId = data.find((blog) => blog.id == projectID);
        setSingleprojectlist(singleprojectlistId);
        setIsLoading(false);
      });
  }, [projectID]);

  return (
    <Container sx={{ border: 0, pt:8 }} maxWidth="lg">
      <Grid container spacing={2} >
        <Grid item xs={12} sm={12}>
          <Typography gutterBottom variant="h5" component="div">
            <SingleProjectCard isLoading={isLoading} key={singleprojectlist?.id} singleprojectlist={singleprojectlist}></SingleProjectCard>
          </Typography>
        </Grid>
      </Grid>
    </Container>
  );
};


export default SingleProject;